const CUSTOM_REPLACEMENTS = [
  { pattern: /ß/gi, value: "ss" },
  { pattern: /æ/gi, value: "ae" },
  { pattern: /œ/gi, value: "oe" },
];

const stripDiacritics = (value) => {
  if (!value) return "";
  let output = value.toString().normalize("NFD");
  CUSTOM_REPLACEMENTS.forEach(({ pattern, value: replacement }) => {
    output = output.replace(pattern, replacement);
  });
  return output.replace(/[\u0300-\u036f]/g, "");
};

const collapseHyphens = (value) =>
  value.replace(/-+/g, "-").replace(/^-|-$/g, "");

const sanitizeSegment = (value) => {
  const stripped = stripDiacritics(value);
  if (!stripped) return "";
  const lowered = stripped.toLowerCase();
  return collapseHyphens(lowered.replace(/[^a-z0-9]+/g, "-"));
};

export const normalizeCrewSlug = (value) => {
  if (!value) return "";
  return collapseHyphens(sanitizeSegment(value));
};

export const buildCrewSlug = (crew) => {
  if (!crew) return "";

  const idPart =
    crew.id !== undefined && crew.id !== null
      ? String(crew.id).replace(/[^0-9]/g, "")
      : "";

  const baseFirst = sanitizeSegment(crew.first_name);
  const baseLast = sanitizeSegment(crew.last_name);
  let namePart = [baseFirst, baseLast].filter(Boolean).join("-");

  if (!namePart && crew.slug) {
    const normalized = normalizeCrewSlug(crew.slug);
    if (normalized) {
      if (idPart && normalized.startsWith(idPart)) {
        const remainder = normalized.slice(idPart.length);
        namePart = collapseHyphens(
          remainder.startsWith("-") ? remainder.slice(1) : remainder,
        );
      } else {
        namePart = normalized.replace(/^[0-9]+-/, "");
        if (!namePart && !idPart) {
          namePart = normalized;
        }
      }
    }
  }

  const parts = [];
  if (idPart) parts.push(idPart);
  if (namePart) parts.push(namePart);

  const slug = collapseHyphens(parts.join("-"));
  if (slug) return slug;

  return idPart || "";
};

export default buildCrewSlug;
